import { types } from "store/sagas/Error";
const initialState = {};

const userError = (state = initialState, action) => {
  return { ...state };
};

export default userError;
